module.exports = __webpack_public_path__ + "img/melia-hotel-2.181ddd78.jpg";